let obj = {
    username: '',
    name: '',
    email: ''
}
export default obj;